export default __webpack_public_path__ + "static/media/nestjs-ar21.36179df4.svg";